import { useState, useEffect } from "react";
import {
    Card,
    Grid,
    Box,
    Typography,
    Fade,
    Button,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// TabPanel Component with Fade-in Animation
function TabPanel({ children, value, index }) {
    return (
        <Fade in={value === index} timeout={500}>
            <Box sx={{ p: 3, display: value === index ? "block" : "none" }}>{children}</Box>
        </Fade>
    );
}

// Function to handle PDF Download
const downloadPDF = () => {
    const { columns, rows } = authorsTableData();
    const doc = new jsPDF();

    doc.text("लोकशाही दिन अहवाल", 14, 10); // Title
    autoTable(doc, {
        head: [columns.map(col => col.accessor)],
        body: rows.map(row => columns.map(col => row[col.accessor])),
        startY: 20,
        theme: "grid",
    });

    doc.save("Lokshahi_Report.pdf");
};

// Function to handle Excel Download
const downloadExcel = () => {
    const { columns, rows } = authorsTableData();
    const worksheetData = [columns.map(col => col.accessor)]; // Headers

    rows.forEach(row => {
        worksheetData.push(columns.map(col => row[col.accessor])); // Row data
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Lokshahi Report");
    XLSX.writeFile(workbook, "Lokshahi_Report.xlsx");
};

// Table Data Function with Updated Data
function authorsTableData() {
    const rows = [
        { srNo: "1", officeName: "Collector Chh Sambhajinagar", totalComplaints: "222", resolved: "219", pending: "3", pendingPercentage: "1%" },
        { srNo: "2", officeName: "Sub-Divisional Sillod", totalComplaints: "6", resolved: "5", pending: "1", pendingPercentage: "17%" },
        { srNo: "3", officeName: "Sub-Divisional Soygaon", totalComplaints: "13", resolved: "3", pending: "10", pendingPercentage: "77%" },
        { srNo: "4", officeName: "Sub-Divisional Vaijapur", totalComplaints: "8", resolved: "7", pending: "1", pendingPercentage: "13%" },
        { srNo: "5", officeName: "Sub-Divisional Gangapur", totalComplaints: "7", resolved: "2", pending: "5", pendingPercentage: "71%" },
        { srNo: "6", officeName: "Taluka Kannad", totalComplaints: "15", resolved: "14", pending: "1", pendingPercentage: "7%" },
        { srNo: "7", officeName: "Taluka Khultabad", totalComplaints: "10", resolved: "7", pending: "3", pendingPercentage: "30%" },
        { srNo: "8", officeName: "Taluka Paithan", totalComplaints: "29", resolved: "29", pending: "0", pendingPercentage: "0%" },
        { srNo: "9", officeName: "Taluka Phulambri", totalComplaints: "12", resolved: "12", pending: "0", pendingPercentage: "0%" },
        { srNo: "10", officeName: "Total", totalComplaints: "365", resolved: "339", pending: "26", pendingPercentage: "6%" },
    ];

    // Make the last row bold
    rows[rows.length - 1] = {
        ...rows[rows.length - 1],
        isBold: true,
    };

    return {
        columns: [
            { Header: "Sr No", accessor: "srNo", align: "center" },
            { Header: "कार्यालय", accessor: "officeName", align: "left" },
            { Header: "एकूण तक्रारी", accessor: "totalComplaints", align: "center" },
            { Header: "निस्कारीत केले", accessor: "resolved", align: "center" },
            { Header: "प्रलंबित", accessor: "pending", align: "center" },
            { Header: "प्रलंबित %", accessor: "pendingPercentage", align: "center" },
        ],
        rows: rows,
    };
}

export default function Lokshahi() {
    const { columns, rows } = authorsTableData();

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box mt={5} mb={3}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <MDTypography variant="h4" color="white">
                                लोकशाही दिन
                            </MDTypography>
                            {/* <Box>
                                <Button
                                    variant="contained"
                                    onClick={downloadPDF}
                                    sx={{
                                        mr: 1,
                                        backgroundColor: "#d32f2f",
                                        boxShadow: "none",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "8px",
                                        "&:hover": { backgroundColor: "#d32f2f" } // Prevent hover color change
                                    }}
                                    startIcon={<PictureAsPdfIcon />}
                                >
                                    Download PDF
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={downloadExcel}
                                    sx={{
                                        backgroundColor: "#388e3c",
                                        boxShadow: "none",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "8px",
                                        "&:hover": { backgroundColor: "#388e3c" } // Prevent hover color change
                                    }}
                                    startIcon={<InsertDriveFileIcon />}
                                >
                                    Download Excel
                                </Button>
                            </Box> */}
                            <Box>
                                <Button
                                    variant="contained"
                                    onClick={downloadPDF}
                                    sx={{
                                        mr: 1,
                                        backgroundColor: "#fff",
                                        boxShadow: "none",
                                        color: "#1976d2",
                                        '&:hover': { backgroundColor: "#fff", boxShadow: "none" }
                                    }}
                                    startIcon={<PictureAsPdfIcon />}
                                >
                                    Download PDF
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={downloadExcel}
                                    sx={{
                                        backgroundColor: "#fff",
                                        boxShadow: "none",
                                        color: "#388e3c",
                                        '&:hover': { backgroundColor: "#fff", boxShadow: "none" }
                                    }}
                                    startIcon={<InsertDriveFileIcon />}
                                >
                                    Download Excel
                                </Button>
                            </Box> 
                        </MDBox>

                        <MDBox pt={3}>
                            <DataTable
                                table={{
                                    columns,
                                    rows: rows.map((row) => ({
                                        ...row,
                                        style: row.isBold ? { fontWeight: 'bold' } : {}
                                    })),
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Box>
        </DashboardLayout>
    );
}
